"use client";

import type { CalendarFestival } from "@/lib/api/calendar";
import { formatDateShort } from "./types";

interface EkadashiSectionProps {
  ekadashis: CalendarFestival[];
}

export function EkadashiSection({ ekadashis }: EkadashiSectionProps) {
  if (ekadashis.length === 0) return null;

  return (
    <div className="mt-8">
      <h2 className="font-serif text-xl font-bold text-ish-dark mb-4">Ekadashi Dates</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {ekadashis.map((ek) => (
          <div
            key={ek.id + ek.date}
            className="flex items-center justify-between p-3 px-4 rounded-xl bg-green-50/50 border border-green-100 transition-colors hover:bg-green-50"
          >
            <div className="flex flex-col">
              <span className="font-semibold text-sm text-ish-dark">{ek.name_en}</span>
              <span className="text-xs text-ish-text-muted">{ek.name_hi}</span>
            </div>
            <span className="text-sm font-bold text-green-700">{formatDateShort(ek.date)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
